import Model, { attr, hasMany, belongsTo } from '@ember-data/model';
import {
  OccasionEvent,
  OccasionPreposition,
  OccasionTermUnit,
} from 'uplisting-frontend/models/occasion';
import { type OccasionFilters } from 'uplisting-frontend/models/advanced-report-configuration';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export interface IUpsellFilter {
  term: number;
  term_unit: OccasionTermUnit;
  preposition: OccasionPreposition;
  event: OccasionEvent;
}

export default class UpsellModel extends Model {
  @attr('string') name!: string;
  @attr('string') nickname!: string;
  @attr('string') description!: string;
  @attr('string') currency!: string;
  @attr('string-or-empty') imageUrl!: null | string;
  @attr('string') s3ImageUrl!: string | null;
  @attr('boolean') requiresApproval!: boolean;
  @attr('array') occasionFilters!: OccasionFilters;
  @attr('object') from!: IUpsellFilter;
  @attr('object') to!: IUpsellFilter;
  @attr('number') price!: number;

  @hasMany('property', { inverse: 'upsells', async: false })
  properties!: ModelRegistry['property'][];

  @belongsTo('tax', { inverse: null, async: false })
  tax!: ModelRegistry['tax'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    upsell: UpsellModel;
  }
}
